// Copyright (c) 2020, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'
import moment from 'moment'

import { SpanWithData, NavLink } from '../../'

export const MessageTableItem = ({ employerId, status, aatErrorMessage, identityId, identityFullName, identityIdentityValue, content, timestamp, action, expandMessage, onClick }) => (
  <tr>
    <td>
      <NavLink to={`/employer/${employerId}/employees/${identityId}`}>
        {identityFullName}
      </NavLink>
    </td>
    <td>
      {identityIdentityValue}
    </td>
    <td title={status === 'AAT_ERROR' ? aatErrorMessage : null}>
      <SpanWithData forField="MessageStatus" searchKey={status} />
    </td>
    <td>
      {timestamp
        ? moment().isSame(moment(timestamp), 'day')
          ? moment(timestamp).format('hh:mm a')
          : moment(timestamp).format('lll')
        : '-'
      }
    </td>
    <td>
      {action}
    </td>
  </tr>
)



// WEBPACK FOOTER //
// ./src/components/messageplus/employer-bulk-message-sms-messages/MessageTableItem.js